export const InputType = {
    PNG: 'image/png',
    JPEG: 'image/jpeg',
    PDF: 'application/pdf',
    MP3: 'audio/mpeg',
    WAV: 'audio/wav',
    MP4: 'video/mp4',
    MPEG: 'video/mpeg',
    MOV: 'video/quicktime',
    MPG: 'video/mpeg',
    WEBM: 'video/webm',
};